import React, {Dispatch, SetStateAction, useEffect, useState} from 'react'
import {KTSVG} from '../../../../_metronic/helpers'
import {Table, Form, Button} from 'react-bootstrap'
import {ContactFileSmsForm, ISenderId} from '../SettingsModel'
import axios from 'axios'
import {useAuth} from '../../auth'
import {BASE_URL} from '../../config'
import toast from 'react-hot-toast'
import {FormikProps} from 'formik'
import {fileUpload, getAdditionalCost, getCost, getSmsType} from '../core/helper'
import {SendingContactFileData} from '../ContactFileSMS'
import {useAppSelector} from '../../../hook'
import {VarInputs} from '../core/_model'
import {formatDateTo12Hour} from '../../../utils/components/FlatPickrDateTime'

const CONTACT_FILE_SMS_URL = `${BASE_URL}/api/protect/contactFileSms`

interface IContactFileSmsProps {
  formData: ContactFileSmsForm
  setIsCreated: React.Dispatch<React.SetStateAction<boolean>>
  setLoading: React.Dispatch<React.SetStateAction<boolean>>
  formik: FormikProps<ContactFileSmsForm>
  varInputs: VarInputs | undefined
}

const ContactFileAndSmsModal: React.FC<IContactFileSmsProps> = ({
  formData,
  setIsCreated,
  setLoading,
  formik,
  varInputs,
}) => {
  const {auth, currentUser} = useAuth()
  const {price, status, additionalPrice} = useAppSelector((state) => state.price)
  const [cost, setCost] = useState<number>(0)
  const [additionalCost, setAdditionalCost] = useState<number>(0)

  const checkVarInputs = Object.values(varInputs ?? {}).every((value) => value !== '')

  let fileData = new FormData()
  fileData.append('file', formData.contact_file)
  const scheduleDate = new Date(formData.schedule_date)

  const sendingData: SendingContactFileData = {
    campaignName: formData.cm_name,
    senderId: (formData.senderid as unknown as ISenderId)?.id,
    smsContent: formData.sms_content,
    smsType: formData.sms_type,
    smsPart: formData.sms_count,
    scheduleDate:
      formData.sms_schedule === 'now' ? new Date().toISOString() : scheduleDate.toISOString(),
    sendNow: formData.sms_schedule === 'now' ? 1 : 0,
    smsLength: formData.smsTextCharacterCount,
    variables: {
      variable: {...varInputs},
    },
  }

  const settingData = async (values: ContactFileSmsForm) => {
    toast.loading('Sending Contact File SMS..')
    setLoading(true)
    let fileData = new FormData()
    fileData.append('file', values.contact_file)

    const fileId = await fileUpload(auth?.accessToken, fileData)

    await sendContactFileSms(fileId, sendingData)

    setLoading(false)
  }

  const sendContactFileSms = async (fileId: number, sendData: SendingContactFileData) => {
    try {
      const response = await axios.post(`${CONTACT_FILE_SMS_URL}/${fileId}`, sendData, {
        headers: {Authorization: `Bearer ${auth?.accessToken}`},
      })
      if (response.status === 201) {
        toast.dismiss()
        toast.success('Successfully send contact file sms')
        setIsCreated(true)
      }
    } catch (error: any) {
      toast.dismiss()
      toast.error(`Error: ${error.message}`)
    }
  }

  useEffect(() => {
    if (formik.isValid && status === 'success' && price.length > 0 && additionalPrice) {
      const cost = getCost(price, formData)
      const additionalCost = getAdditionalCost(additionalPrice, formData)

      setCost(cost)
      setAdditionalCost(additionalCost)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formik.isValid, price, additionalPrice, status, formData])

  return (
    <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
      <div className={`${formik.isValid ? 'modal-dialog modal-xl' : 'modal-dialog'}`}>
        <div className='modal-content'>
          <div className='modal-header'>
            <h5 className='modal-title fs-2'>SMS Summary</h5>
            <div
              className='btn btn-icon btn-sm btn-active-light-primary ms-2'
              data-bs-dismiss='modal'
              aria-label='Close'
            >
              <KTSVG
                path='/media/icons/duotune/arrows/arr061.svg'
                className='svg-icon svg-icon-2x'
              />
            </div>
          </div>
          <div className='modal-body'>
            <div className='modal-body'>
              {formik.isValid && checkVarInputs ? (
                <div className='d-flex gap-16'>
                  <div className='w-50'>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Campaign name</p>
                      <p className='fs-3 fw-medium'>{formData.cm_name}</p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>SMS type</p>
                      <p className='fs-3 fw-medium'>{getSmsType(formData.sms_type)}</p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>SMS Count</p>
                      <p className='fs-3 fw-medium'>{formData.sms_count}</p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Total Recipeint</p>
                      <p className='fs-3 fw-medium'>{formData.reciepient}</p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Number of SMS</p>
                      <p className='fs-3 fw-medium'>{formData.noOfSms}</p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Sender Id</p>
                      <p className='fs-3 fw-medium'>
                        {typeof formData.senderid === 'string'
                          ? formData!.senderid
                          : formData.senderid?.value}
                      </p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Schedule</p>
                      <p className='fs-3 fw-medium'>
                        {formData.sms_schedule === 'now'
                          ? 'Now'
                          : `${formatDateTo12Hour(scheduleDate)}`}
                      </p>
                    </div>
                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Cost</p>
                      <p className='fs-3 fw-medium'>{cost.toFixed(2)} BDT</p>
                    </div>

                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Additional Cost</p>
                      <p className='fs-3 fw-medium'>{additionalCost.toFixed(2)} BDT</p>
                    </div>

                    <div className='d-flex align-items-center justify-content-between'>
                      <p className='fs-3 fw-medium'>Total</p>
                      <p className='fs-3 fw-medium'>{(cost + additionalCost).toFixed(2)} BDT</p>
                    </div>
                  </div>

                  <div className='w-50'>
                    <p className='fs-3 fw-medium'>SMS preview</p>
                    <div
                      className='fs-5 p-4 bg-light rounded-2 border border-info overflow-scroll'
                      style={{whiteSpace: 'pre-wrap', height: '370px'}}
                    >
                      {formData.sms_content}
                    </div>
                  </div>
                </div>
              ) : (
                <div className='alert alert-primary d-flex align-items-center' role='alert'>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='24'
                    height='24'
                    fill='currentColor'
                    className='bi bi-exclamation-triangle-fill flex-shrink-0 me-2'
                    viewBox='0 0 16 16'
                    role='img'
                    aria-label='Warning:'
                  >
                    <path d='M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z' />
                  </svg>
                  <div className='fs-4 fw-semibold'>Please fill up the required field.</div>
                </div>
              )}
            </div>
            {/* {!formData ? null : (
              <>
                <div className='d-flex align-items-center justify-content-between'>
                  <p className='fs-3 fw-medium'>SMS type</p>
                  <p className='fs-3 fw-medium'>{getSmsType(formData.sms_type)}</p>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <p className='fs-3 fw-medium'>SMS Count</p>
                  <p className='fs-3 fw-medium'>{formData.sms_count}</p>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <p className='fs-3 fw-medium'>Sender Id</p>
                  <p className='fs-3 fw-medium'>
                    {typeof formData.senderid === 'string'
                      ? formData!.senderid
                      : formData.senderid?.value}
                  </p>
                </div>
                <div className='d-flex align-items-center justify-content-between'>
                  <p className='fs-3 fw-medium'>Schedule</p>
                  <p className='fs-3 fw-medium'>{contactSmsData.scheduleDate}</p>
                </div>
                <br></br>
                <div>
                  <p className='fs-3 fw-medium'>SMS preview</p>
                  <p className='fs-5 p-2 bg-info rounded-2' style={{color: 'white'}}>
                    {formData.sms_content}
                  </p>
                </div>
              </>
            )} */}
          </div>
          <div className='modal-footer'>
            <div>
              <Button variant='secondary' data-bs-dismiss='modal' aria-label='Close'>
                Close
              </Button>{' '}
              <Button
                type='button'
                variant='primary'
                data-bs-dismiss='modal'
                aria-label='Close'
                onClick={() => settingData(formData)}
              >
                Send
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ContactFileAndSmsModal
